<div class="xp-paginator__summary"><ng-content></ng-content></div>
<mat-paginator [length]="length()"
			   [pageIndex]="pageIndex()"
			   [pageSize]="pageSize()"
			   [pageSizeOptions]="pageSizeOptions()"
			   [hidePageSize]="hidePageSize()"
			   [showFirstLastButtons]="showFirstLastButtons()"
			   [attr.aria-label]="ariaLabel()"
			   (page)="page.emit($event)"></mat-paginator>
